import moment from 'moment';
import { DictionaryContextType } from '../dictionaries/context/DictionaryContextTypes';
import { BankType, BrandType, NegotiationOption, NegotiationOptionAlternative, OutDebt, OutDebtFieldsFragment } from '../generated/graphql';
import thousandSeparator from './thousandSeparator';

type ContentTotalPaymentBancoBogotaType = {
  gT: (key: string, context?: DictionaryContextType) => string,
  outDebt: OutDebt,
  negOption?: NegotiationOption,
  outDebts?: Array<OutDebtFieldsFragment>,
  alternative?: NegotiationOptionAlternative,
  isConsequences?: boolean,
};

enum BancoBogotaTotalPaymentKeys {
  General = 'alert_paymentAlert_content_totalPayment',
  Consequences = 'negotiation_TotalPayment_consequences',
}

const { General, Consequences } = BancoBogotaTotalPaymentKeys;
export const getContentTotalPaymentBancoBogota = (
  props : ContentTotalPaymentBancoBogotaType,
) => {
  const { gT, outDebts, outDebt, isConsequences, negOption: option, alternative } = props;

  if (!option || !alternative) return null;

  const isMultiDebt = outDebts && outDebts.filter(({ bank, brand }) => (
    bank === BankType.BancoDeBogota && brand === BrandType.Tranquiapp
  )).length > 1;

  const outDebtHeadProductNumber = outDebts?.find(({ bank, brand, extra }) => (
    bank === BankType.BancoDeBogota && brand === BrandType.Tranquiapp && extra?.headProductNumber
  ))?.productNumber || '';

  const context = {
    monthlyPayment: thousandSeparator(alternative.value),
    negPaymentDate: moment(option.settings?.maxPaymentDate).format('LL'),
    productNumber: outDebt.productNumber || '',
    bank: outDebt.bank,
    headProductNumber: outDebtHeadProductNumber || '',
  };

  const showMultiDebt = isMultiDebt
  && outDebtHeadProductNumber
  && !outDebt.productNumber?.includes(outDebtHeadProductNumber)
  && !outDebt.negotiation;

  const validateMultidebt = (text: string) => `${text}${showMultiDebt ? '_multidebt' : ''}`;

  const text = gT(validateMultidebt(isConsequences ? Consequences : General), context);

  return [ text ].join(' ');
};
